import { VList } from '@sleepstation/components-layouts'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { getKeyFromLinks } from '../../helpers'
import VerticalMenuItem from './VerticalMenuItem'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VList).attrs({ 'data-cy': `vertical-menu` })`
  z-index: 2;
  background-color: #032841;
  width: 250px;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const VerticalMenu = ({ links, setMenuIsOpen }) => (
  <Layout>
    {renderList(
      ({ linkUrl, iconKey, linkText }) => (
        <VerticalMenuItem
          linkUrl={linkUrl}
          iconKey={iconKey}
          linkText={linkText}
          setMenuIsOpen={setMenuIsOpen}
        />
      ),
      links,
      { idFunc: getKeyFromLinks(links) }
    )}
  </Layout>
)

VerticalMenu.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object).isRequired,
  setMenuIsOpen: PropTypes.func.isRequired,
}

export default VerticalMenu
